import useBlock from 'hooks/block'

export default function ButtonGroups({ studioAccount }) {
  const t = useI18n()
  const { user } = useCurrent()
  const panel = usePanel()
  const { blockActionWrapper } = useBlock(studioAccount?.user.id)
  if (!studioAccount) return ''

  const openBuyDeposit = () => {
    if (!user) return panel.open('auth')
    h.openBuyDeposit({
      stylistId: studioAccount.id,
      stylistUserId: studioAccount.user.id,
      stylistName: studioAccount.user.name
    })
  }

  const openPrepayBooking = () => $openPrepayBooking({
    stylistId: studioAccount.id,
    stylistUserId: studioAccount.user.id,
    stylistName: studioAccount.user.name
  })

  const renderDepositButton = () => {
    if (!studioAccount.depositSupported) return
    return <Button onClick={ () => blockActionWrapper(openBuyDeposit) }>{ t('page:userId.deposit') }</Button>
  }

  return (
    <div className='pt-8'>
      <div className='flex space-x-3'>
        <Button onClick={ () => blockActionWrapper(() => { $messenger.talkToUser(studioAccount.user.id) }) }>
          { t('page:userId.message') }
        </Button>
        { renderDepositButton() }
        <div className='flex-1 hidden md:block'>
          <Button onClick={ () => blockActionWrapper(openPrepayBooking) }>
            { t('page:studioId.book') }
          </Button>
        </div>
      </div>
    </div>
  )
}

const Button = ({ children, onClick, reverse }) => {
  const style = () => {
    if (reverse) return 'bg-black text-white hover:opacity-70'
    return 'hover:bg-black hover:text-white'
  }
  return (
    <div
      onClick={ onClick }
      className={ cn('text-center flex-1 border rounded p-1 text-sm font-bold cursor-pointer transition-all', style()) }
    >
      { children }
    </div>
  )
}
